import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setAccessToken, setFullName, setPermissions,setRoleTitle,setRoleTitleAdmin,setSelectedPeriod,setComparePeriod } from "../../../core/redux/action";
import { setStoreData } from "../../../core/redux/filters/filter.action.jsx";
import { setKpiData, setKpiData2 } from "../../../core/redux/filters/filter.action.jsx";

import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import { APIAuthenticateSSO,APIKpis } from '../../../api/authSSO.ts';
import { useNavigate } from "react-router-dom";

import { APIFetchStores } from "../../../helpers/filterstores.ts";
import LanguageSelector  from "../../../LanguageSelector.js";
import { fetchStoreData } from "../../../core/redux/stores/stores.action.jsx";
//
const SignIn = () => {
  const translation = useSelector(state => state.root.translation);

  // const changeLanguage = (lng) => {
  //   i18n.changeLanguage(lng);
  // };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [, setCount] = useState(0);

  useEffect(() => {
    const storedEmail = localStorage.getItem("rememberedEmail");
    if (storedEmail) {
      setEmail(storedEmail);
      
      setRememberMe(true);
    }
  }, []);
//   const googleLogin = () => {
//     const sso = "https://sso.forgedrift.com/";//localStorage.getItem('sso');
//     const hostApp = location.protocol + "//" + location.host;
//     const url = `${sso}/api/authGoogle?hostapp=${hostApp}`;
//     window.open(url, '_blank');

// };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setErrors(prevErrors => ({ ...prevErrors, email: false }));

  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setErrors(prevErrors => ({ ...prevErrors, password: false }));

  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleRememberMeChange = () => {
    setRememberMe(!rememberMe);
  };

  const validateForm = () => {
    const errors = {};
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!email) {
      errors.email = translation["email_required"];
    } else if (!emailPattern.test(email)) {
      errors.email = translation["invalid_email_address"];
    }
    if (!password) {
      errors.password = translation["password_required"];
    }
    return errors;
  };

  const route = all_routes;
  const handleSubmit = async (e) => {
    
    localStorage.setItem('listKpis',null);
    e.preventDefault(); // Prevent the default form submission behavior
    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }
    setErrors({}); // Clear previous errors if any

    try {
      const response = await APIAuthenticateSSO({
        username: email,
        password: password
      });
      if (response.status?.toString() !== '200') {
        throw new Error('Authentication failed');
      }

      const res = response.response;
      const accessToken = res.authentication.access_token;
      const defaultSelectedPeriod = res.role?.config?.selectedPeriod?res.role.config.selectedPeriod: "LAST_WEEK";
      const defaultComparePeriod = res.role?.config?.comparePeriod?res.role.config.comparePeriod:"PREVIOUS_PERIOD";
      const tenantId = res.tenant._id;
      const userId = res._id
      const fullName = response.response?.profile?.fullName;
      const email1 = response.response?.email;
      const getPermissions =  response.response?.role?.permissions;
   

      const roleTitle =  response.response?.role?.title;
      
      let permissions;
      if(getPermissions && getPermissions.length>0)
      {
        permissions = getPermissions.map(item => {
        const parts = item.title.split(':');
        const module = parts[1];
        const permission = parts[3];
        return {
              Module: module.trim(),
              Permission: permission.trim()
          };
        });
      }
      localStorage.setItem('permissions', JSON.stringify(permissions));
     if (accessToken) {
        localStorage.setItem('accessToken', accessToken);
        dispatch(setAccessToken({accessToken, tenantId, userId}));
        
        dispatch(setSelectedPeriod({defaultSelectedPeriod}));
        dispatch(setComparePeriod({defaultComparePeriod}));
        console.log("Sign in selected_period",defaultSelectedPeriod);
        console.log("Sign in compare_period",defaultComparePeriod);

        localStorage.setItem("selected_period",defaultSelectedPeriod) || null,
        localStorage.setItem("compare_period",defaultComparePeriod)
        localStorage.setItem("userId",userId)
        const payload = {fullName, email: email1}
        dispatch(setFullName(payload));
        dispatch(setPermissions(permissions));
        dispatch(setRoleTitle(roleTitle));
        localStorage.setItem("roleTitle", roleTitle);
        dispatch(setRoleTitleAdmin('TenantAdmin'));
       
        
        const res = await APIFetchStores("all");
        await fetchStoreData(accessToken);

        if(res?.data?.dataAccessStores[0]?.storeNumber)
        {
          console.log('store1',res?.data?.dataAccessStores[0]?.storeNumber)
          dispatch(setStoreData({ selectedLocationStore: [res?.data?.dataAccessStores[0]?.storeNumber] }));
        }
        else
        {
          
          console.log('store2',res?.data?.dataAccessStores[0]?.storeNumber)
          const selectedStoreNumber = res?.data?.myStores[0]?.storeNumber?res.data.myStores[0].storeNumber:null
          dispatch(setStoreData({ selectedLocationStore: [selectedStoreNumber] }));

        }

      const kpisList = await APIKpis();
      var allKpis = kpisList?.response?.map(item => item.key);
      allKpis = allKpis.filter(kpi => kpi !== "trf" && kpi !== "dm" && kpi !== "bug");
      // dispatch(setKpiData2({ listKpis2: allKpis }));
      console.log("allkpis",allKpis);
      const kpisString = allKpis.join(',')
      
      localStorage.setItem('listKpis', kpisString);
      dispatch(setKpiData2({ listKpis2: allKpis }));

      
      //fetchStoreData
      
      const kpisArray = allKpis.slice(0, 4);

      dispatch(setKpiData({ kpisSelected: kpisArray }));

      if (rememberMe) {
        localStorage.setItem("rememberedEmail", email);
      } else {
        localStorage.removeItem("rememberedEmail");
      }
      console.log('permissions',permissions);
     
     // const adminDashboardPermission = permissions.find(p => p.Module === "admin-dashboard");
      // if(adminDashboardPermission)
      //   navigate(route.dashboardV2);
      // else 
     if(route.home){
      navigate(route.home);
     }else{
      if(permissions?.find(p => p.Module === "operations") ||  roleTitle == 'TenantAdmin')
        navigate(route.operations);
      else if(permissions?.find(p => p.Module === "marketing"))
        navigate(route.marketing);
      else if(permissions?.find(p => p.Module === "staffing"))
        navigate(route.staffing);
      else if(permissions?.find(p => p.Module === "analytics"))
        navigate(route.analytics);
      else
      {
        const firstModule = permissions.length > 0 ? permissions[0].Module : null;

        if (firstModule) {
          navigate(route[firstModule]);

        } else {
            console.log("No modules available.");
        }
    
     
      }
     }
      }
    } catch (error) {
      console.error('SignIn Error', error);
      setErrors({ general: 'Invalid email or password' });
    }
  };
  const serverChange = () => {
    setCount((prev) => {
      const newCount = prev + 1;
      const serverOn = localStorage.getItem("on") || 'stg';
      const on = serverOn === "stg" || !serverOn ? "prod" : "stg";
      if (newCount === 5) {
        localStorage.clear();
        localStorage.setItem("on", on);
        window.location.reload();
      }
      return newCount;
    });
    setTimeout(() => {
      setCount(0);
    }, 3000);
  };

  return (
    <div className="main-wrapper">
      <div className="account-content">
        <div className="login-wrapper">
        <div className="login-img" style={{ position: 'relative',  justifyContent: 'center', alignItems: 'center' }}>
            <img src="assets/img/authentication/login02.png" alt="img" />
            
            <div className="overlay" style={{ 
              position: 'absolute', 
              top: '50%', 
              left: '50%', 
              width: '100%', 
              height: '100%', 
              border: '1px solid',
              backgroundColor: '#00000099', 
              display: 'flex', 
              flexDirection: 'column', 
              justifyContent: 'center', 
              alignItems: 'center', 
              color: '#fff', 
              textAlign: 'center', 
              transform: 'translate(-50%, -50%)',
            
            }}>
              <h1 style={{ fontSize: '42px',Weight:'600', marginBottom: '2rem', color:"white" }}>{translation?.welcome || "Welcome!"}</h1>
              <p style={{ fontSize: '36px',Weight:'600',lineHeight: '48.41px', marginTop: '2rem' }}>
              {/* {t("stock_up_smart_save_big_always") || "Stock Up Smart, Save Big Always!"}<br />
              {t("your_inventory_our_expertise") || "Your Inventory, Our Expertise."} */}
              {translation?.stock_up_smart_save_big_always || "“Unlock smarter strategies for sustainable growth.”"}
              </p>
            </div>
          </div>
          <div className="login-content">
            <form style={{ width: '80%' }} onSubmit={handleSubmit}>
            
              <div className="login-userset">
                <div className="login-logo logo-normal">
                <ImageWithBasePath src="assets/img/logo.png" alt="img" />
                </div>
                
                <div className="login-userheading">
                  <h3 onClick={serverChange} style={localStorage.getItem('on') == 'prod' ? {} : {color:"red"}}>{translation?.sign_in || "Sign In"}</h3>
                  <h4>{translation?.access_sign_in}</h4>
                </div>
                <div className="form-login">
                  <label>{translation?.email_address}</label>
                  <div className="form-addons">
                    <input
                      type="text"
                      className="form-control"
                      value={email}
                      onChange={handleEmailChange}
                    />
                    <ImageWithBasePath src="assets/img/icons/mail.svg" alt="img" />
                  </div>
                  {errors.email && <span className="error-message" style={{ color: 'red' }}>{errors.email}</span>}
                </div>
                <div className="form-login">
                  <label>{translation?.password}</label>
                  <div className="pass-group">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="pass-input"
                      value={password}
                      onChange={handlePasswordChange}
                    />
                    <span
                      className={`fas toggle-password ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`}
                      onClick={togglePasswordVisibility}
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                  {errors.password && <span className="error-message" style={{ color: 'red' }}>{errors.password}</span>}
                </div>
                <div className="form-login authentication-check">
                  <div className="row">
                    <div className="col-6">
                      <div className="custom-control custom-checkbox">
                        <label className="checkboxs ps-4 mb-0 pb-0 line-height-1">
                          <input
                            type="checkbox"
                            checked={rememberMe}
                            onChange={handleRememberMeChange}
                          />
                          <span className="checkmarks" />
                          {translation?.remember_me}
                        </label>
                      </div>
                    </div>
                    <div className="col-6 text-end">
                      <Link className="forgot-link" to={route.forgotPasswordTwo}>
                      {translation?.forgot_password}
                      </Link>
                    </div>
                  </div>
                </div>
                {errors.general && <span className="error-message" style={{ color: 'red' }}>{errors.general}</span>}
                <div className="form-login">
                  <button type="submit" className="btn btn-login">Sign In</button>
                </div>
                <div className="signinform">
                  <h4>
                  {translation?.new_on_our_platform}
                    <Link to={route.registerTwo} className="hover-a"> {translation?.create_an_account}</Link>
                  </h4>
                    <LanguageSelector />          
                </div>
                {/* <div className="form-setlogin or-text">
                  <h4>{t('or')}</h4>
                </div> */}
                <div className="form-sociallink">
                  {/* <ul className="d-flex">
                    <li style={{width:"100%"}}>
                      <Link onClick={googleLogin}>
                        <ImageWithBasePath src="assets/img/icons/google.png" alt="Google" />
                      </Link>
                    </li>
                  </ul> */}
                  <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
                    <p>{translation?.copyright_message}</p>
                  </div>
                </div>
              </div>
            </form>
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default SignIn;
